// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')

/**
 * AssignContentSetsCtrl controller
 *
 * @class AssignContentSetsCtrl
 * @memberof mwApp/common
 * @see mwApp/common
 *
 * @ngdoc controller
 * @name mwApp/common.controller:AssignContentSetsCtrl
 */
/* @ngInject */
export default function AssignContentSetsCtrl ($scope, $state, $http, $uibModal, alertLiteSvc, authSvc, contentItem, allContentSets, allNetworksById, historySvc) {
  const vm = this
  vm.isNew = false
  vm.hasContentSetsIntersection = false
  vm.contentSetsIntersectionBySubscriptionId = {}
  vm.contentSetsIntersectionByContentSetId = {}
  vm.networkFromContentSet = {}

  vm.contentItem = contentItem

  vm.networks = allNetworksById

  vm.hasEditSubscriptionPermission = authSvc.hasAccess('editSubscription')

  vm.prepareContentSets = function (contentSetsArr) {
    const contentSets = {}
    for (const contentSet of contentSetsArr) {
      if (!contentSets[contentSet.networkId]) {
        contentSets[contentSet.networkId] = []
      }

      contentSets[contentSet.networkId].push(contentSet)
    }

    return Object.entries(contentSets).map(([networkId, contentSets]) => ({ networkId, contentSets, name: vm.networks[networkId]?.name }))
  }

  vm.items = {
    available: { networks: vm.prepareContentSets(allContentSets) },
    assigned: { networks: vm.prepareContentSets(contentItem.contentSets) }
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, type, link, fromType) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    vm.draggableType = type
    vm.fromType = fromType
    if (type === 'contentSets') {
      vm.networkFromContentSet = angular.copy(list)
      vm.networkFromContentSet.contentSets = []
    }
    link.selected = true
    return list[type].filter(link => link.selected)
  }

  // see http://marceljuenemann.github.io/angular-drag-and-drop-lists/demo/#/multi

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, type, items, index, toType) {
    $scope.form.$setDirty()
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    const fromTo = `${vm.draggableType}.${type}`
    let foundedNetwork
    let foundedContentSet

    if (vm.fromType === toType) {
      items.forEach(item => { item.selected = false })
      return false
    }

    items.forEach((item) => { item.assigned = toType === 'assigned' })

    switch (fromTo) {
      case 'networks.networks' :
        for (const item of items) {
          foundedNetwork = list.networks.find(network => network.networkId === item.networkId)

          if (foundedNetwork) {
            for (const contentSet of item.contentSets) {
              if (!foundedNetwork.contentSets.find(cs => cs.id === contentSet.id)) {
                foundedNetwork.contentSets.push(contentSet)
              }
            }

            foundedNetwork.assigned = item.assigned
            foundedNetwork.contentSets.forEach(contentSet => {
              contentSet.assigned = false
            })
          } else {
            list.networks = list.networks.slice(0, index).concat(item).concat(list.networks.slice(index))
          }
          item.selected = false
        }
        return true

      case 'contentSets.networks' :
        foundedNetwork = list.networks.find(network => network.networkId === vm.networkFromContentSet.networkId)
        if (foundedNetwork) {
          foundedNetwork.assigned = false
          const foundedFromContentSet = foundedNetwork.contentSets.find(contentSet => contentSet.id === items[0].id)
          if (foundedFromContentSet) {
            foundedFromContentSet.assigned = items[0].assigned
          } else {
            foundedNetwork.contentSets.push(items[0])
          }
        } else {
          const network = angular.copy(vm.networkFromContentSet)
          network.contentSets = [items[0]]
          list.networks = list.networks.slice(0, index).concat([network]).concat(list.networks.slice(index))
        }
        items.forEach(item => { item.selected = false })
        return true

      case 'contentSets.contentSets':
        if (vm.networkFromContentSet.networkId !== list.networkId) {
          return false
        }
        foundedContentSet = list.contentSets.find(contentSets => contentSets.id === items[0].id)
        if (foundedContentSet) {
          foundedContentSet.assigned = items[0].assigned
        } else {
          list.contentSets.push(items[0])
        }
        list.assigned = false
        items.forEach(item => { item.selected = false })
        return true
      default :
        items.forEach(item => { item.selected = false })
        items[0].assigned = !items[0].assigned
        return false
    }
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list, fromType) {
    list.forEach(item => { item.selected = false })
    list.dragging = false

    if (fromType === 'available' || vm.hasContentSetsIntersection) {
      vm.checkIntersection()
    }
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list, type) {
    let fromNetwork
    if (vm.fromType === 'assigned') {
      if (type === 'contentSets') {
        fromNetwork = vm.items.available.networks.find(network => network.id === vm.networkFromContentSet.id)
        if (vm.networkFromContentSet.assigned) {
          fromNetwork.assigned = false
          fromNetwork.contentSets.forEach(contentSet => { contentSet.assigned = true })
        }
      }
    }
    list[type] = list[type].filter(item => !item.selected)

    vm.hasContentSetsPriceConflict = false
  }

  /**
   * Method for select/deselect items
   *
   * @param item
   * @param event
   * @memberof mwApp/packages.controller:AddShowSetCtrl
   */
  vm.selectItem = function (item, event) {
    event.stopPropagation()
    event.preventDefault()
    item.selected = !item.selected
  }

  vm.deleteContentSet = function (network, contentSet) {
    vm.getSelected(network, 'contentSets', contentSet, 'assigned', network)
    vm.onDrop(vm.items.available, 'networks', [angular.copy(contentSet)], 0, 'available')
    vm.onMoved(network, 'contentSets')
    vm.checkIntersection({ checkOnDelete: true })
  }

  vm.openConflicts = function (itemWithIntersection) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    // eslint-disable-next-line no-undef
    event.preventDefault()

    itemWithIntersection.openConflict = true

    $uibModal.open({
      templateUrl: 'components/packages/popups/contentItemIntersectionModal.html',
      controller: 'ContentItemIntersectionModalCtrl as vm',
      windowClass: 'modal-class-conflict',
      backdrop: true,
      animation: false,
      resolve: {
        editedEntity: function () {
          return vm.contentItem
        },
        itemWithIntersection: function () {
          return itemWithIntersection
        },
        contentSetsIntersectionBySubscriptionId: function () {
          return vm.contentSetsIntersectionBySubscriptionId
        },
        contentSetsIntersectionByContentSetId: function () {
          return vm.contentSetsIntersectionByContentSetId
        },
        checkIntersection: function () {
          return vm.checkIntersection
        }
      }
    })
      .result
      .then(
        function close () {
          itemWithIntersection.openConflict = false
        },
        function dismiss () {
          itemWithIntersection.openConflict = false
        })
  }

  vm.openSetContentItemPrice = function (requiredPrices) {
    return $uibModal.open({
      templateUrl: 'components/common/components/assignContentSets/newItemsPrice.html',
      controller: 'NewItemsPriceCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        subscriptions: function () {
          return requiredPrices
        },
        cs: function () {
          return {}
        }
      }
    })
      .result
      .then(
        function close (assignedSubscriptions) {
          Object.assign(contentItem, { assignedSubscriptions })
          vm.saveContentItem()
        })
  }

  vm.checkContentItemPriceError = function (assignedContentSets) {
    if (!assignedContentSets.length) { return vm.saveContentItem() }
    const contentSetId = assignedContentSets.map(({ id }) => id).join(',')
    const typesForLink = {
      channel: 'channels',
      le: 'live-events',
      vod: 'vods',
      show: 'tvshows',
      season: `tvshows/${contentItem.tvShow?.id}/seasons`,
      episode: `tvshows/${contentItem.tvShow?.id}/episodes`
    }

    const url = `/nora/api/${typesForLink[contentItem.$itemType]}/extra/subscriptions`
    return $http.get(url, { params: { withRequiredPerItemPrice: true, contentId: contentItem.id, contentSetId } })
      .data()
      .then((resp) => resp.payload)
      .then(requiredPrices => {
        if (!requiredPrices.length) {
          vm.saveContentItem()
          return
        }

        if (vm.hasEditSubscriptionPermission) {
          vm.openSetContentItemPrice(requiredPrices)
          return
        }

        vm.hasContentSetsPriceConflict = !!requiredPrices.length
        contentItem.contentSets.forEach(set => { set.priceConflicts = false })
        for (const price of requiredPrices) {
          contentItem.contentSets
            .filter(set => set.id === price.contentSet.id)
            .forEach(set => { set.priceConflicts = true })
        }
      })
      .catch(rejection => alertLiteSvc.alertError(rejection?.statusText))
  }

  vm.checkIntersection = function (params = { checkOnDelete: false, assignedContentSets: null }) {
    if (!vm.items.assigned.networks.length) { return Promise.resolve([]) }

    const { checkOnDelete, assignedContentSets } = params
    if (checkOnDelete && !vm.hasContentSetsIntersection) { return Promise.resolve([]) }

    const ids = (assignedContentSets || vm.getAssignedContentSets()).map(({ id }) => id).join(',')
    if (!ids.length) { return Promise.resolve([]) }

    const typesForLink = {
      channel: 'channels',
      le: 'live-events',
      vod: 'vods',
      show: 'tvshows',
      season: 'tvshows',
      episode: 'tvshows'
    }
    const url = `/nora/api/${typesForLink[contentItem.$itemType]}/extra/content-sets/intersection`
    vm.contentSetsIntersectionByContentSetId = {}
    vm.contentSetsIntersectionBySubscriptionId = {}
    vm.setDisable()

    return $http.get(url, { params: { ids } })
      .data()
      .then((resp) => resp.payload)
      .then((data) => {
        vm.hasContentSetsIntersection = !!data.length

        for (const conflict of data) {
          if (!vm.contentSetsIntersectionByContentSetId[conflict.contentSetId]) { vm.contentSetsIntersectionByContentSetId[conflict.contentSetId] = [] }
          vm.contentSetsIntersectionByContentSetId[conflict.contentSetId].push(conflict)

          if (!vm.contentSetsIntersectionBySubscriptionId[conflict.subscriptionId]) { vm.contentSetsIntersectionBySubscriptionId[conflict.subscriptionId] = [] }
          vm.contentSetsIntersectionBySubscriptionId[conflict.subscriptionId].push(conflict)
        }
      })
      .catch(rejection => alertLiteSvc.alertError(rejection?.statusText))
      .finally(vm.unsetDisable)
  }

  vm.saveContentItem = function () {
    return angular.copy(contentItem)._save()
      .then(vm.goBack)
  }

  vm.getAssignedContentSets = function () {
    return vm.items.assigned.networks.reduce((acc, network) => [...acc, ...network.contentSets], [])
  }

  vm.submit = function () {
    const contentSets = vm.getAssignedContentSets()
    Object.assign(contentItem, { contentSets })

    if (!contentSets.length) { return vm.saveContentItem() }

    vm.checkIntersection({ assignedContentSets: contentSets })
      .then(() => !vm.hasContentSetsIntersection && vm.checkContentItemPriceError(contentSets))
  }

  vm.goBack = function () {
    if (historySvc.canPop()) {
      historySvc.pop(undefined, false)
    }
    $state.go($state.router.globals.$current.parent.name + '.edit', {}, { reload: true })
  }

  /**
   * redirect to content item if content invalid (without streamPolicy)
   */
  $scope.$on('$viewContentLoaded', function () {
    if (!contentItem?.defaultStream?.mediaUrl?.mediaUrl && !['season', 'show'].includes(contentItem.$itemType)) {
      vm.goBack()
    }
  })
}
